import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { PUBLIC_URL, DOC_URL } from '../../../constants';
import { withTranslation } from 'react-i18next';
import { FormGroup, Button, Checkbox, H3, TextArea, ProgressBar, MenuItem, Collapse } from '@blueprintjs/core';
import { FRONT_USER_ROLE_COOKIE_NAME } from '../../../auth/constants';
import Cookies from 'js-cookie';
import { openConlluPopup } from '../../../utils'
import './QueryDef.css';
import { MultiSelect } from '@blueprintjs/select';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import SpecialProgressBarSuggest from './SpecialProgressBarSuggest';



class QueryDef extends React.PureComponent {

  state = {
    query: '',
    suggestions: [],  // in each: query (string), example (string), svg (str), freq (number)
    waitingSuggestion:false,
    suggestionDisplayed:false, // indicate if the suggestion has been searched with the current query
    wideSearch:false, // to control the display of the widenSearch button
    lemmatizeExample:true,
    svgData:"",
    filterDivIsOpen:false,
    filteringAttr:[],
    filteringVals:[],  // all the possible values for a given filteringAttr
    selectedFilteringVals:[], // the selected filtering values
    allAttrs:[],
    attr_val:null,
    isTQLOn:false,
    caseInsensitive:false
  };

  fetchMetadata=()=> {
    const data = {
      corpus: this.props.corpus,
    };

    const endpoint = '/get_metadata.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        this.setState({ waitingSuggestion:false });
        return;
      }
      res.json().then(data => {
        const allAttrs=data.__all_attrs__;
        delete(data.nbToks);
        delete(data.nbToks);
        delete(data.__all_attrs__);
        this.setState({allAttrs:allAttrs,attr_val:data})
        //console.log('data',data);
      }).catch(() => {
        console.log('json pas lisible');
      })
    })
    .catch(() => {
      console.log(`Network error when trying to fetch ${endpoint}`);
    });
  };

  handleBoolChange = (e) => {
    const name = e.target.name;
    this.setState(prevState => ({ [name]: !prevState[name] }));
  }

  selectSuggestedQuery = (suggQuery, suggSvg) => {
    this.setState({ query: suggQuery, svgData: suggSvg, isTQLOn: true });
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // for smoothly scrolling
    });
  }

  clearQuery=() => {
    this.setState({ isTQLOn:false, query: "", suggestionDisplayed:false });
  }

  handleQueryUpdate = (e) => {
    // ending spaces are deleted in the query
    const newQuery = e.target.value;
    const newIsTQLOn = newQuery.match(/</);
  
    this.setState({ isTQLOn:newIsTQLOn, query: newQuery, suggestionDisplayed:false }, () => {
      if (newIsTQLOn) {
        let format='tql';
        if (newQuery.match(/\d+\t(.*\t){7}/)) {
          format='conll'; 
        }
        this.debouncedFetchQuerySVG(format);
      }
      // the pastedQuery in the parent state will be cleared !
      this.props.clearPastedQuery(); 
    });
    
  }

  fetchQuerySuggestions = (widenSearch) => {
    // building a temporary fileName for first temporary Result
    const tmpName=Date.now().toString()+"_"+Math.random(100).toString()+".json";

    const data = {
      query: this.state.query.replace(/^\s*|\s*$/g,""),
      corpus: this.props.corpus,
      widenSearch: widenSearch,
      tmpName: tmpName,
      lemmatizeExample: this.state.lemmatizeExample
    };
    if (this.props.params) {
      data.params = this.props.params;
    }

    const endpoint = '/get_examples.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        this.setState({ waitingSuggestion:false });
        return;
      }
      res.json().then((data) => {
        if (data.session_id) {
          // Note that the example list is cleared
          this.setState({ session_id : data.session_id, waitingSuggestion:true,  suggestions:[], suggestionDisplayed:true, wideSearch:widenSearch, tmpName:tmpName });
          // console.log("recherche d'exemple en cours");
        }
      });
            
    })
    .catch(() => {
      this.setState({ waitingSuggestion:false });
      console.log(`Network error when trying to fetch ${endpoint}`);
    })

  }

  setExamples=(data)=> {
    //console.log("Ajout de",data.examples);
    if (data.completed) {
      this.setState({ suggestions: data.examples, waitingSuggestion:false });
    } else {
      this.setState({ suggestions: data.examples });
    }
  }
  

  onlySyntax=()=> {
    const q=this.state.query;
    this.setState({query:q.replace(
                    /[lw]=[^,]+,(c=(NOUN|VERB|ADJ|ADV))/g,
                    function(match,group1){return group1})
                  });
  }

  debouncedFetchQuerySuggestions = _.debounce(this.fetchQuerySuggestions , 4000);
    // Note: debouncing a property function in the class syntax
    // is not that straightforward. Best to proceed like here, create
    // a variable which stores the debounced function, then call that
    // function.

  debouncedFetchQuerySVG = _.debounce((format) => {
      // seulement pour user +
      if (Cookies.get(FRONT_USER_ROLE_COOKIE_NAME)!=='user+') {
        return; 
      };
      const data = {
        query: this.state.query,
        format: format
      };
  
      const endpoint = '/query2svg.ajax.php';
      fetch(
        process.env.REACT_APP_API_BASE + endpoint, {
          credentials: process.env.REACT_APP_CREDENTIALS,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        }
      )
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((data) => {
          this.setState({ svgData:data.svg });   
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
    }, 1000);

  runQuery = () => {
    // calling props.onQueryReady is the way to notify `Dashboard`
    // to run the search query to the backend
      const query= (this.props.pastedQuery) ? this.props.pastedQuery:this.state.query.replace(/^\s*|\s*$/g,"");
      if (query.trim() !=="") {
        this.props.onQueryReady(query,false,this.state.caseInsensitive);
    }
  }

  runGeneralize = () => {
    // calling props.onQueryReady is the way to notify `Dashboard`
    // to run the search query to the backend
    this.props.onQueryReady(this.state.query.replace(/^\s*|\s*$/g,""),true,this.state.caseInsensitive);
  }

  onChangeFilteringAttr= (e) => {
    e.preventDefault();
    const {value} = e.target;
    if (this.state.attr_val[value]) {
      this.setState({filteringAttr:value,filteringVals:this.state.attr_val[value]});
    }
  };
  addTheCriterion= () => {
    if (this.state.filteringAttr && this.state.selectedFilteringVals.length>0) {
      var addedCriterion;
      if (this.state.selectedFilteringVals.length>1) {
        addedCriterion="docMeta("+this.state.filteringAttr+")=~/^("+this.state.selectedFilteringVals.join('|')+')$/';
      } else {
        addedCriterion="docMeta("+this.state.filteringAttr+")=\""+this.state.selectedFilteringVals[0].replace(/"/,'\\"')+'"';
      }
      const query=this.state.query;
      const newQuery=query.indexOf("::")>-1? query+"&& "+addedCriterion: query+":: "+addedCriterion;
      this.setState({ query: newQuery});
    }
  };


  filterElements = (query, filterElement) => {
    const filterItem = filterElement;
    const filterItemUpper = filterItem.toUpperCase();
    const queryUpper = query.toUpperCase();
    return filterItemUpper.includes(queryUpper);
  }

  addSelectedFilter = (filterItem) => {
    const selectedFilteringVals=this.state.selectedFilteringVals;
    if (selectedFilteringVals.indexOf(filterItem)===-1) {
      selectedFilteringVals.push(filterItem);
      this.setState({selectedFilteringVals:[...selectedFilteringVals] });
    }
  }

  removeSelectedFilter = (filterItem) => {
    const selectedFilteringVals=this.state.selectedFilteringVals;
    selectedFilteringVals.splice(selectedFilteringVals.indexOf(filterItem),1);
    this.setState({selectedFilteringVals:[...selectedFilteringVals] });
  }


  render() {
    const { isTQLOn, suggestions, svgData, waitingSuggestion, lemmatizeExample, caseInsensitive } = this.state;
    const { t, corpus } = this.props;

    const query= this.props.pastedQuery ? this.props.pastedQuery : this.state.query;

    const userPlus = (Cookies.get(FRONT_USER_ROLE_COOKIE_NAME)==='user+') ? true: false ;
    const suggestionCards = suggestions.map( sugg => {
      const suggCardBorder = classNames('QueryDef__suggestionCard', {
        'neutral-card': sugg.query !== query,
        'active-card': sugg.query === query,
      });
      var freq=sugg.freq;
      var collection=sugg.collection;
      var sentId=sugg.sentId;
      var lang=corpus.language;

      if (sugg.freq===0) {
        freq=1
      }
      return (
        <div
          key={sugg.query}
          className={suggCardBorder}
        >
          <p>{t('queryColon')} {sugg.query}</p>
          <div  onClick={() => this.selectSuggestedQuery(sugg.query, sugg.svg)}
                dangerouslySetInnerHTML={{__html:sugg.svg}}>
          </div>

        { freq &&  
          <p>{t('estimatedFrequencyColon')} {freq}</p>
        } 
          <p> {t('exampleColon')}  
            <Button onClick={ ()=>{ openConlluPopup(lang,collection,sentId) }} icon='layout-linear' />
          </p>
          {sugg.example}
        { ! freq &&
          <p>
            <ProgressBar/>
          </p>
        }
        </div>
      );
    });

    const commonInputProps = {
      placeholder: t('typeAQuery'),
      name: "query",
      onChange: this.handleQueryUpdate,
      value: query,
      className: "QueryDef__input",
    };

    return(
      <div className="QueryDef__wrapper">
        <div className="flex flex-between margin-bottom-1-rem">

          <TextArea {...commonInputProps} />
         
          {(!isTQLOn && ! waitingSuggestion ) &&  
            <Button text={t('suggest')} onClick={()=>this.fetchQuerySuggestions(false)} className='bp3-minimal'/>
          }
          {(isTQLOn && ! waitingSuggestion ) &&  
            <Button text={t('clear')} onClick={this.clearQuery} className='bp3-minimal'/>
          }
          <Button text={t('go')} onClick={this.runQuery}  className='bp3-intent-primary'/>
         
        </div>

        <FormGroup
          inline={true}
        >
          <Checkbox name='isTQLOn' checked={this.state.isTQLOn} label={t('tql')} inline={true} onChange={this.handleBoolChange} disabled={true} />

          {(isTQLOn) &&
            <Button name='eraseContentLemmas' onClick={this.onlySyntax} inline={true} >{t('eraseContentLemmas')}</Button>
          }
          {(!isTQLOn) &&
            <Checkbox name='lemmatizeExample' checked={lemmatizeExample} label={t('lemmatizeExample')} onChange={this.handleBoolChange} />
          }            
          <Checkbox name='caseInsensitive' checked={caseInsensitive} label={t('caseInsensitive')} onChange={this.handleBoolChange} />
          
        </FormGroup>

        { isTQLOn &&
          <div style={{marginBottom:20}}>
            <Button minimal={true} onClick={() => { 
                  if (! this.state.attr_val) {
                    this.fetchMetadata();
                  }
                  this.setState({ filterDivIsOpen: !this.state.filterDivIsOpen })
                }
              }>
                      {this.state.isOpen ? "-" : "+"} {t('metadataFilters')}
            </Button>

            <Collapse isOpen={this.state.filterDivIsOpen} >
              <div className='flex'>
                <EnhancedSingleSelect
                  options={this.state.allAttrs}
                  hasDefault={true}
                  hasSelectableDefault={true}
                  label={t('filteringAttr')}
                  name={"filteringAttr"}
                  onChange={this.onChangeFilteringAttr}
                  popoverProps={{ minimal: true }}
                />
                <MultiSelect
                  label={t('filteringVals')}
                  items={this.state.filteringVals}
                  itemRenderer={
                    (item, { handleClick, modifiers }) => (
                      <MenuItem
                        key={"menuItems"+item}
                        active={modifiers.active}
                        text={item}
                        icon={this.state.selectedFilteringVals.includes(item) ? 'tick' : 'blank'}
                        onClick={handleClick}
                        shouldDismissPopover={false}
                      />
                    )
                  }
                  itemPredicate={(query, filterElement) => this.filterElements(query, filterElement)}
                  onItemSelect={(filterElement) => this.addSelectedFilter(filterElement)}
                  onRemove={(filterElement) => this.removeSelectedFilter(filterElement) }
                  selectedItems={this.state.selectedFilteringVals}
                  tagInputProps={{
                    interactive: true,
                    onRemove: (filterElement) => this.removeSelectedFilter(filterElement),
                  }}
                  // tagRenderer takes as input what selectedItems gives
                  tagRenderer={filterLabel => filterLabel}
                  noResults={<MenuItem disabled={true} text={t('noResult')} />}
                  placeholder={t('filteringVal')}
                />
              </div>
              <Button className="bp4-button bp4-small bp4-intent-primary" onClick={this.addTheCriterion}>{t('addTheCriterion')}</Button>
            </Collapse>
          </div>
        }


        <div className="QueryDef__suggestionsWrapper">
          {query && svgData && isTQLOn && userPlus &&
            <>
              <div dangerouslySetInnerHTML={{__html:svgData}}></div>
            </>
          }

          {query && isTQLOn && userPlus &&
            <>
              <Button text={t('generalize')} onClick={this.runGeneralize}  className='bp3-intent-primary'/>
              <br/>
            </>
          }

          {/* { isTQLOn && !  (svgData && query)  &&
            <>
              <p><b>{t('exemplesOfAdvancedQueriesColon')}</b></p>
              <p>
                {'"<l=considération,c=N,#1>"'}
                <br/>
                {'"<l=prendre,c=V,#1>&& <l=en,c=PREP,#2> &&<l=considération,c=N,#3>::(advl,1,3) (pm,3,2)"'}
              </p>
            </>
          } */}

          {! isTQLOn &&
            <p>
              {t('suggestExplanation')}
            </p>

          }
          <br/>
          <p>{t('referenceTQLColon')}  
              <a href={PUBLIC_URL+DOC_URL+'/Reference TQL.fr.pdf'} target='blank'> [FR]</a> 
              <a href={PUBLIC_URL+DOC_URL+'/Reference TQL.en.pdf'} target='blank'> [EN]</a>
          </p>

          { query && suggestions.length > 0 && // !isTQLOn &&
            <div style={{'marginTop': '3rem'}}>
              <H3>{t('suggestionOfAdvancedQueries')}</H3>
              <p>{t('suggestedQueriesExplanation')}</p>
              <br/>
              {suggestionCards}
            </div>
          }

          {! waitingSuggestion && query && !isTQLOn && this.state.suggestionDisplayed && ! this.state.wideSearch && // 
            <div style={{'marginTop': '3rem'}}>
               <Button text={t('widenSearch')} onClick={()=> this.fetchQuerySuggestions(true) } />
            </div>
          }

          {  waitingSuggestion &&
            <div style={{'marginTop': '3rem'}}>
              <H3>{t('suggestionOfAdvancedQueries')}</H3>
              <SpecialProgressBarSuggest 
                  session_id={this.state.session_id} 
                  tmpName={this.state.tmpName}
                  setExamples={this.setExamples}
                  stopWaitingSuggestion={ ()=> this.setState({ waitingSuggestion:false } )}
              />
            </div>
          }
        </div>

      </div>
    );
  }
}

QueryDef.propTypes = {
  onQueryReady: PropTypes.func,
  corpus: PropTypes.object,
  params: PropTypes.object,
  pastedQuery: PropTypes.string,
  clearPastedQuery: PropTypes.func,
};

export default withTranslation()(QueryDef);
